import {ControlAccessor} from '../../models/ControlAccessor';
import {Input} from "@angular/core";
import {coerceBooleanProperty} from "@angular/cdk/coercion";
import zxcvbn, {ZXCVBNResult, ZXCVBNScore} from 'zxcvbn'
import {PasswordStrengthColor, PasswordStrengthLabel} from "./input.model";

export abstract class AzInputBase extends ControlAccessor {
    
    @Input()
    get passwordVisibility(): boolean {
        return this._passwordVisibility
    }
    
    set passwordVisibility(value: boolean) {
        const newVisibility = coerceBooleanProperty(value)
        if (newVisibility !== this._passwordVisibility) {
            this._passwordVisibility = newVisibility
        }
    }
    
    get inputType(): string {
        if (this.type === 'password') {
            return this.passwordVisibility ? 'text' : 'password'
        }
        return this.type || 'text'
    }
    
    get passwordStrengthResult(): { score: ZXCVBNScore, label: string, color: string } {
        
        if (this.type !== 'password') return
        
        const result: ZXCVBNResult = zxcvbn(this.control.value)
        
        return {
            score: result.score,
            label: PasswordStrengthLabel[result.score],
            color: PasswordStrengthColor[result.score]
        }
    }
    
    
    /** Whether the input show password  */
    private _passwordVisibility: boolean


//  Keyboard & Clipboard Event  //
    
    onKeyPress = (e: KeyboardEvent) => {
        e.stopPropagation();
        if (e.keyCode === 13) this.enter.emit();
    };
    
    onKeyDown = (e: KeyboardEvent) => {
        e.stopPropagation();
        
        
        return (this.type === 'number')
                ? this.onNumberKeyDown(e)
                : (this.type === 'phone')
                        ? this.onPhoneKeyDown(e)
                        : null;
    };
    
    onPaste = (e: ClipboardEvent) => {
        e.stopPropagation();
        return (this.type === 'number')
                ? this.onNumberPaste(e)
                : (this.type === 'phone')
                        ? this.onPhonePaste(e)
                        : null;
    };
    
    
    // Ensure that it is a number from [0-9] no decimal_point
    
    onPhoneKeyDown = (e: KeyboardEvent) => {
        e.stopPropagation();
        // Allow
        if (
                e.keyCode === 8 ||      // backspace
                e.keyCode === 9 ||          // Tab
                e.keyCode === 13 ||       // enter
                (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||      //  Ctrl + A
                (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||       //  Ctrl + C
                (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||        //  Ctrl + X
                (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||        //  Ctrl + V
                (e.keyCode >= 35 && e.keyCode <= 39)                             // home, end, left, right
        ) {
            return;
        }
        
        
        // Reject if not a number or numpad
        if (
                (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&       // not number
                (e.keyCode < 96 || e.keyCode > 105)                                     // not numpad
        ) {
            e.preventDefault();
        }
        
    };
    
    // Ensure that pasted value is a number or string of number
    onPhonePaste = (e: ClipboardEvent) => {
        e.stopPropagation();
        if (!/^\d+$/.test(e.clipboardData.getData('Text'))) {
            e.preventDefault();
        }
    };
    
    
    // Ensure that it is a  number: integer || decimal
    onNumberKeyDown = (e: KeyboardEvent) => {
        e.stopPropagation();
        // Allow
        if (
                e.keyCode === 8 ||      // backspace
                e.keyCode === 9 ||          // Tab
                e.keyCode === 13 ||       // enter
                e.keyCode === 188 ||    // comma(",")
                e.keyCode === 110 ||        //   numpad decimal point
                e.keyCode === 190 ||        // period(".")
                (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||      //  Ctrl + A
                (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||       //  Ctrl + C
                (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||        //  Ctrl + X
                (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||        //  Ctrl + V
                (e.keyCode >= 35 && e.keyCode <= 39)                             // home, end, left, right
        ) {
            return;
        }
        
        
        // Reject if not a number or numpad
        if (
                (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&       // not number
                (e.keyCode < 96 || e.keyCode > 105)                                     // not numpad
        ) {
            e.preventDefault();
        }
        
    };
    
    // Ensure that pasted value is a string of number: integer || decimal
    onNumberPaste = (e: ClipboardEvent) => {
        e.stopPropagation();
        if (!/^\d.+$/.test(e.clipboardData.getData('Text'))) {
            e.preventDefault();
        }
    };
}
